import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'
import { SVGIconProps } from 'commonTypes'

const ExpertIcon = ({ fill, ...props }: SVGIconProps) => {
    return (
        <SvgIcon viewBox="0 0 512.000000 512.000000" {...props}>
            <g
                transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                fill={fill ?? '#09293E'}
                stroke="none"
            >
                <path
                    d="M2395 5110 c-399 -62 -725 -365 -827 -766 -22 -87 -23 -103 -23 -584
                    l1 -495 26 -97 c64 -232 193 -429 369 -560 l69 -51 0 -56 0 -56 -578 -149
                    c-317 -82 -613 -162 -656 -178 -110 -39 -205 -98 -293 -182 -125 -118 -198
                    -237 -250 -403 l-28 -88 -3 -679 c-2 -508 0 -687 9 -708 26 -62 -147 -58 2349
                    -58 2499 0 2323 -4 2349 58 9 20 11 80 9 187 l-3 157 -28 24 c-41 35 -99 33
                    -138 -5 -28 -28 -29 -33 -29 -125 l0 -96 -1030 0 -1030 0 0 330 0 331 308 659
                    c169 363 313 660 320 660 25 0 138 -63 210 -117 130 -99 226 -235 284 -403
                    l33 -95 3 -280 3 -280 -46 -24 c-170 -89 -207 -334 -72 -474 64 -65 126 -91
                    217 -91 127 -1 230 65 282 179 32 70 31 180 -2 250 -29 58 -84 116 -139 144
                    l-39 20 -5 288 c-4 258 -7 296 -26 368 -28 100 -97 247 -155 331 -25 35 -42
                    64 -38 64 4 0 111 -27 237 -60 263 -69 358 -110 454 -196 70 -64 119 -128 160
                    -210 43 -86 60 -156 70 -279 7 -100 10 -110 35 -132 37 -32 95 -31 133 1 28
                    24 28 25 27 143 -1 96 -7 135 -28 206 -50 166 -121 283 -248 402 -95 90 -176
                    141 -284 181 -40 14 -335 94 -656 178 l-583 152 -3 55 c-3 55 -3 55 42 87 187
                    135 329 344 394 579 l26 98 1 495 c0 481 -1 497 -23 584 -94 371 -371 651
                    -740 747 -89 24 -320 34 -417 19z m393 -220 c237 -67 438 -245 528 -468 40
                    -100 55 -173 61 -306 l6 -129 -29 7 c-63 15 -152 67 -208 123 -48 47 -57 61
                    -52 83 18 82 28 170 22 194 -28 112 -196 94 -196 -21 0 -55 -26 -147 -55 -198
                    -36 -60 -116 -132 -183 -163 l-57 -27 -444 -3 -444 -3 6 133 c6 149 24 228 73
                    336 113 247 345 421 619 466 71 11 281 -3 353 -24z m257 -953 c78 -65 175
                    -114 268 -136 l69 -16 -5 -250 c-5 -289 -15 -345 -91 -493 -103 -198 -278
                    -345 -491 -412 -95 -30 -299 -38 -403 -16 -266 56 -492 249 -595 507 -43 108
                    -57 217 -57 450 l0 208 458 3 c447 4 458 4 519 27 76 28 164 84 218 138 22 22
                    41 41 43 42 1 0 32 -23 67 -52z m-104 -1633 c14 -15 48 -32 82 -41 44 -13 57
                    -21 54 -32 -12 -43 -512 -1099 -518 -1093 -5 5 -497 1054 -515 1097 -2 6 25
                    19 61 29 85 24 105 48 105 127 0 33 4 59 10 59 5 0 45 -10 87 -22 69 -20 100
                    -23 258 -22 161 0 188 3 260 25 l80 24 6 -62 c4 -48 12 -69 30 -89z m-787
                    -775 l306 -656 0 -336 0 -337 -1030 0 -1031 0 3 612 c4 686 0 646 80 799 68
                    132 187 244 324 305 41 18 495 144 519 144 2 0 -16 -29 -41 -64 -61 -88 -128
                    -233 -155 -336 -12 -47 -24 -134 -28 -194 l-6 -109 -47 -14 c-120 -34 -248
                    -163 -289 -291 -20 -60 -23 -93 -26 -307 -5 -323 1 -335 170 -335 127 0 167
                    25 167 105 0 53 -44 95 -100 95 l-42 0 4 178 c4 198 14 236 79 300 54 55 104
                    76 184 76 60 1 78 -3 125 -30 60 -33 112 -99 130 -162 5 -20 10 -110 10 -199
                    l0 -163 -46 0 c-60 0 -104 -40 -104 -95 0 -82 39 -105 181 -105 l101 0 34 34
                    34 34 0 230 c0 126 -5 253 -10 283 -32 168 -157 303 -334 363 -17 6 -18 15
                    -14 109 15 290 200 563 467 691 41 20 75 35 76 33 1 -1 140 -297 309 -658z
                    m1836 -736 c41 -37 48 -86 20 -131 -38 -61 -117 -67 -164 -11 -82 97 50 226
                    144 142z"
                />
                <path
                    d="M4753 876 c-23 -20 -28 -32 -28 -71 0 -60 35 -95 95 -95 60 0 95 35
                    95 95 0 60 -35 95 -95 95 -27 0 -48 -8 -67 -24z"
                />
                <path
                    d="M2933 695 c-34 -24 -47 -76 -29 -118 17 -43 41 -57 94 -57 33 0 45 6
                    66 31 17 19 26 43 26 64 0 21 -9 45 -26 64 -21 26 -33 31 -68 31 -23 0 -51 -7
                    -63 -15z"
                />
            </g>
        </SvgIcon>
    )
}

export default ExpertIcon
